export enum DeheadingPrevOperationEnum{
    GRN = 'GRN',
    GRADING = 'GRADING',
    PACKING = 'PACKING'
}

export enum GradingPrevOperationEnum{
    GRN = 'GRN',
    DEHEADING = 'DEHEADING',
}

export enum ValueAdditionPrevOperationEnum{
    GRADING = 'GRADING',
    VALUE_ADDITION = 'VALUE ADDITION',
    COOKING = 'COOKING',
    PACKING = 'PACKING',
    SOAKING = 'SOAKING'
}

export enum SoakingPrevOperationEnum{
    GRADING = 'GRADING',
    VALUE_ADDITION = 'VALUE ADDITION',
    PACKING = 'PACKING'
}